import styled from 'styled-components';

export const BoxScore = styled.div`
  border-radius: 10px;
  color: var(--ant-primary-color);
  padding: 5px 10px;
  font-size: 14px;
  border: 1px solid var(--ant-primary-color);
  display: inline-block;
  margin-top: 2rem;
`;
